import { transformOfferEvent } from '@core/mappers/offer/transformOfferEvent';
import OfferEvent from '@core/models/offer/OfferEvent';

import { AbstractSseConnection } from './AbstractSseConnection';
import { MatchEvent } from '../types';
import { OfferEventDto } from '@core/mappers/offer/dtos/OfferEventDto';
import { getOfferSseHost } from '@core/services/offer/helpers';

export class MatchDetailsSseConnection extends AbstractSseConnection<OfferEvent> {
    constructor(eventId: number) {
        super(`events/${eventId}`, getOfferSseHost());
    }

    // eslint-disable-next-line class-methods-use-this
    processSseEvents(events: MatchEvent[]): OfferEvent {
        return transformOfferEvent(events[events.length - 1].data as OfferEventDto);
    }

    updateMatchDetailsTimestamp(event: OfferEvent) {
        this.timestampsMap[`match:${event.id}`] = event.matchTimestamp;
    }
}
